var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"statistic-chart"},[_c('highcharts',{attrs:{"options":_vm.customOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }